<div
  [ngClass]="templateColumns()"
  class="grid gap-4 py-3">
  <ng-content />
</div>
